import Cookies from 'js-cookie'
import helper from 'vuejs-object-helper';

const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get('sidebarStatus'),
      withoutAnimation: false
    },
    device: 'desktop',
    tabs: {},
    configs: {},
    accordions: {},
    filterSPreserve: {},
    filterBPreserve: {},
    filterSerPreserve: {}
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
      state.sidebar.withoutAnimation = false
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 1)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    setAppKey(state, {key, value}) {
      helper.setProp(state, key, value)
    },
    deleteAppKey(state, {key}) {
      helper.deleteProp(state, key)
    },
    FILTER_STATE_S_PRESERVE: (state,filtered) => {
      state.filterSPreserve = filtered
    },
    FILTER_STATE_B_PRESERVE: (state,filtered) => {
      state.filterBPreserve = filtered
    },
    FILTER_STATE_SER_PRESERVE: (state,filtered) => {
      state.filterSerPreserve = filtered
    },
  },
  actions: {
    ToggleSideBar: ({ commit }) => {
      commit('TOGGLE_SIDEBAR')
    },
    CloseSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    ToggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
    updateAppKey({ commit }, {key, value}){
      commit('setAppKey', {key, value})
    },
    deleteAppKey({ commit }, {key, value}){
      commit('deleteAppKey', {key})
    },
    filterStateSPreserve: ({ commit }, filtered) => {
      commit('FILTER_STATE_S_PRESERVE', filtered)
    },
    filterStateBPreserve: ({ commit }, filtered) => {
      commit('FILTER_STATE_B_PRESERVE', filtered)
    },
    filterStateSerPreserve: ({ commit }, filtered) => {
      commit('FILTER_STATE_SER_PRESERVE', filtered)
    },
  }
}

export default app
